import React from 'react'
import style from '../card.module.css'

function Amarjeet() {
  return (
    <div className={style.review_students}>
        <p>
        nice platform to those who want to do big in their life... 
        top educators and nice secessions..      
        </p>    
      <div className={style.review_students_name_start}>
          <div>
            <h2>Lt Amarjeet singh</h2>  
            <p>13,749 learning minutes • NDA</p> 
          </div>
          <div>
            <h1>⭐⭐⭐⭐⭐</h1>  
            <p>1 month ago</p>  
          </div>
      </div>  
    </div>
  )
}
export default Amarjeet